export default __webpack_public_path__ + "static/media/two-text.680dbc12.svg";